import { ActionsEnum } from '../../Basic/enums/actions.enum';
import { LeftSidebarListItemButton } from './left-sidebar-list-item-button.model';
import { QuotaUsageIndicatorEnum } from '../../../Monitor/Shared/enums/quota-usage-indicator.enum';

export class LeftSidebarListItem {
    label: string;
    icon?: string;
    iconAriaLabel?: string;
    value: any; // id or object this refers to
    lastModifiedDate?: number;
    status: string | number;
    buttons: LeftSidebarListItemButton[];
    styleClass?: string;
    state?: ActionsEnum;
    secondaryOption?: string;
    groupId?: number;
    isFavorite?: boolean;
    disabled?: boolean;
    tooltip?: string;
    indicator?: string;
    indicatorTooltip?: string;
    /** A marker drawn ahead of the item's own icon, with the tooltip that explains it */
    leadingIcon?: string;
    leadingIconTooltip?: string;
}

export class LeftSidebarSubitem {
    resourceId: number;
    id: number | string;
    label?: string;
}
